// extracted by mini-css-extract-plugin
export default {"SpeechBox":"c2EpDbEY","container":"BeTBlGvs","name":"aC7mIWfP","message":"JI0VjtAR","pb150":"eOODN73m"};
    if(module.hot) {
      // 1712151479982
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  